import Link from 'next/link'
import { Space, Typography } from 'antd'
import TruncatedId from './TruncatedId'
import type { Dataset } from '@/models/ecs'

type DatasetLinkProps = {
  dataset: Dataset
  primary?: boolean
  nameOnly?: boolean
}

const DatasetLink = ({
  dataset,
  primary = false,
  nameOnly = true,
}: DatasetLinkProps) => {
  return (
    <Space direction='vertical'>
      <Link type='link' href={`/ecs/datasets/${dataset.id}`}>
        {primary ? (
          <Typography.Link>{dataset.name}</Typography.Link>
        ) : (
          <Typography.Text>{dataset.name}</Typography.Text>
        )}
      </Link>
      {!nameOnly && <TruncatedId id={dataset.id} />}
    </Space>
  )
}

export default DatasetLink
